
window.scoopOS = new Vue({
    data() {
        return {
            selectedModels: Scoop.selectedModels.state,
            tools: Scoop.selectedModels.tools,
        }
    },
    created() {
        this.$on('model.selectionChanged', model => {
            this.refreshModelTools(model);
        });
        this.$on('models.changed', (model) => {
            // Called, when relevent informations of an model has changed, which then can change the result
            // of model tools
            this.refreshModelTools(model);
        });
    },
    methods: {
        getSelected(model) {
            return this.selectedModels[model] || [];
        },
        isSelected(model, id) {
            return _.indexOf(this.getSelected(model), id) !== -1;
        },
        countSelected(model) {
            return this.getSelected(model).length;
        },
        deselectAll(model, callback) {
            scoopOS.$emit('model.selectionChanging', model, []);

            Vue.set(this.selectedModels, model, []);
            axios.post(Scoop.baseUrl + '/modelSelector/model/deselectAll', { model: model }).then(response => {
                scoopOS.$emit('model.selectionChanged', model, response.data);

                if (callback) {
                    callback(model);
                }
            });
        },
        toggle(model, id, callback) {
            let state = this.getSelected(model);

            const existingIndex = _.indexOf(state, id);

            if (existingIndex !== -1) {
                state.splice(existingIndex, 1);
            } else {
                state.push(id);
            }

            this.replaceAll(model, state, callback);
        },
        replaceAll(model, ids, callback) {
            this.replaceAllDebounced(model, ids, callback);
        },
        replaceAllDebounced: _.debounce((model, ids, callback) => {
            scoopOS.$emit('model.selectionChanging', model, scoopOS.selectedModels[model]);

            Vue.set(scoopOS.selectedModels, model, ids);

            axios.post(Scoop.baseUrl + '/modelSelector/model/'+model+'/select', {
                replaceAll: ids
            }).then(response => {
                scoopOS.$emit('model.selectionChanged', model, response.data);

                if (callback) {
                    callback(model, response.data);
                }
            });
        }, 200),
        refreshModelTools(model, callback) {
            this.refreshModelToolsAllDebounced(model, callback);
        },
        refreshModelToolsAllDebounced: _.debounce((model, callback) => {
            scoopOS.$emit('model.toolsLoading', model);

            Vue.set(scoopOS.tools, model, null);

            axios.get(Scoop.baseUrl + '/modelSelector/model/'+model+'/tools').then(response => {
                Vue.set(scoopOS.tools, model, response.data.tools);

                scoopOS.$emit('model.toolsLoaded', model, response.data);

                if (callback) {
                    callback(model, response.data);
                }
            });
        }, 200),
    }
});